<template>
    <div>
        <div>
            Visão Geral
        </div>

        <button type="button" class="btn btn-primary" @click="solicitar()">
            Solicitar
        </button>
    </div>
</template>

<script>
export default {
    methods: { 
        solicitar () { 
            let solicgeral = this.$util.get_solic_geral();
            solicgeral.solicitar();
            // this.$refs.solic.solicitar();
        }
    },

    mounted() { 
        this.$store.commit("setBreadcrumb", [
            { name: "Suprimentos", path: "/suprimentos/visao" },
            { name: "Visão Geral", path: "/suprimentos/visao" }
        ]);
    }
}
</script>